function ContactPage () {

    return (
        <div className="App">
            <div className="App-body">
                <h1>Contact.</h1>
                <b>Phone</b>
                <ul style={{listStyleType:'none'}}>
                    <li>FMCSA Gateway Help Desk: 855.537.7517</li>
                    <li>FMCSA Drug and Alcohol Clearinghouse Help Desk: 844.955.0207</li>
                    <li>FMCSA Login.gov Help Desk: 844.875.6446</li>
                </ul>
                <b>Email</b>
                <ul style={{listStyleType:'none'}}>
                    <li>FMCSA Gateway Help Desk: fmcsasupport NOREPLY@obxtek.com</li>
                    <li>FMCSA Drug and Alcohol Clearinghouse Help Desk: clearinghouse@dot.gov</li>
                    <li>FMCSA Login.gov Help Desk: Login.gov Contact Page Home</li>
                </ul>
            </div>
        </div>
    );
}

export default ContactPage;